// extracted by mini-css-extract-plugin
export var content = "section-block-module--content--77cef text-content-module--wrapper--bdd0a";